module.exports = __webpack_public_path__ + "img/8.b2d1a77c.jpg";